import React from 'react';
import { Button, Container, Header, Modal } from 'semantic-ui-react';

interface AssistanceAndCoverageDetailsProps {
  open: boolean;
  type: 'assistance' | 'coverage';
  onClose: () => void;
}

const AssistanceAndCoverageDetailsModal = ({
  open,
  type,
  onClose
}: AssistanceAndCoverageDetailsProps) => {
  const pdfUrlAssistance =
    'https://s3.us-east-1.amazonaws.com/app.ladobom.com/yellum-assistencias.pdf';
  const pdfUrlCoverage =
    'https://s3.us-east-1.amazonaws.com/app.ladobom.com/yellum-coberturas.pdf';

  return (
    <>
      <Modal open={open} onClose={onClose} size="large" style={{ height: '80vh' }}>
        <Modal.Header>
          <Header>Assistências - Yellum Seguros</Header>
        </Modal.Header>
        <Modal.Content>
          <Container>
            <iframe
              src={type === 'assistance' ? pdfUrlAssistance : pdfUrlCoverage}
              width="100%"
              height="100%"
              style={{ border: 'none', height: '60vh' }}
              title="PDF Viewer"
            />
          </Container>
        </Modal.Content>

        <Modal.Actions>
          <Button onClick={onClose} color={'green'}>
            Fechar
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
};

export default AssistanceAndCoverageDetailsModal;
